import { Component, computed, input, InputSignal, Signal } from '@angular/core';

import { CardsBlockPosition, CardsBlockSection } from '@core/cms/landing.cms';
import { CmsBtn } from '@shared/ui/cms-btn/cms-btn';
import { CmsImage } from '@shared/ui/cms-image/cms-image';
import { TrustHtmlPipe } from '@shared/pipes/trust-html/trust-html.pipe';

/**
 * Renders a `ComponentSectionCardsBlock`: a title, a row/column grid of cards (tag, image, content,
 * CTA) and an optional list of section-level buttons. Cards with no image fall back to the brand
 * asterisk glyph used by the home `app-complexity` cards.
 */
@Component({
    selector: 'cms-cards-block',
    imports: [CmsBtn, CmsImage, TrustHtmlPipe],
    templateUrl: './cards-block.html',
    styleUrl: './cards-block.scss',
})
export class CmsCardsBlock {
    public readonly section: InputSignal<CardsBlockSection> = input.required<CardsBlockSection>();

    /** A `column` block lays the intro beside a single-column grid; a `row` block is a full grid. */
    protected readonly isColumn: Signal<boolean> = computed(
        (): boolean => this.section().position === CardsBlockPosition.Column,
    );
}
